'use strict';

require('./ReportByBeerStyle.scss');

const React = require('react'),
  {t} = require('services/i18nextWrapper'),
    BeerStyleStore = require('stores/BeerStyleStore'),
    ReportStore = require('stores/ReportStore'),
    DropDown = require('components/Commons/DropDown/DropDown'),
    ContentUtils = require('utils/ContentUtils'),
    InventoryStore = require('stores/InventoryStore'),
    {DatePicker, Toggle, RadioButtonGroup, RadioButton, CircularProgress} = require('material-ui'),
   {map, filter, find} = require('lodash/collection'),
    ComponentUtils = require('utils/ComponentUtils'),
    {cloneDeep} = require('lodash/lang'),
    get = require('lodash/object').get,
    FormGroupButton = require('components/Commons/BasicForm/FormGroupButton/FormGroupButton'),
    GridItemWithFilter = require('components/Commons/GridItem/GridItemWithFilter');

const FILTER_BY_OPTIONS = ['Month', 'Week', 'Day'].map((name, index) => {
    return {
        payload: index + 1,
        name
    };
});

const ReportByBeerStyle = React.createClass({displayName: "ReportByBeerStyle",

    getInitialState() {
        return {
            filter: {
                moduleName: 'REPORT_BY_BEER_STYLES',
                isDetailedByBeerStyle: false,
                isAllSelected: true,
                dateTo: new Date(),
                dateFrom: new Date(),
                isShowConfirmed: true,
                selectedBeerStyleIds: [],
                reportKey: '',
                filterByOptionIndex: 0,
                isGeneratingReport: false,
                isFetching: true
            }
        };
    },

    componentDidMount() {
        const self = this;
        this.setState({isFetching: true});
        BeerStyleStore.fetchStyleBeers(function (beerStyles) {
            self.setState(prevState => {

                prevState.beerStyles = map(beerStyles, beerStyle => {
                    beerStyle.iconClassName = '';
                    return beerStyle;
                });

                prevState.filter.selectedBeerStyleIds = map(beerStyles, beerStyle => {
                    return get(beerStyle, 'id');
                });
                
                prevState.isFetching = false;

                return prevState;
            });
        });
    },

    isSelectedBeerStyle(item) {
        return this.state.filter.selectedBeerStyleIds.indexOf(item.id) > -1;
    },

    isChangedBeerStyle() {
        return false;
    },

    onChangeBeerStyle(item) {
        const self = this;
        this.setState(prevState => {
            if (ContentUtils.isNullOrEmpty(prevState.filter.selectedBeerStyleIds)) {
                prevState.filter.selectedBeerStyleIds = [];
            }

            const isAlreadySelected = prevState.filter.selectedBeerStyleIds.indexOf(item.iconId) > -1;
            if (item.isChecked && isAlreadySelected) {
                prevState.filter.selectedBeerStyleIds = filter(prevState.filter.selectedBeerStyleIds, id => id !== item.iconId);
            } else if (!item.isChecked && !isAlreadySelected) {
                prevState.filter.selectedBeerStyleIds.push(item.iconId);
            }

            item.isChecked = !item.isChecked;
            prevState.filter.isAllSelected = self._isAllSelected(prevState);

            return prevState;
        });
    },

    onChangeFrom(nil, dateFrom) {
        //this.refs.dateFrom.setDate(dateFrom);
        this.setState(prevState => {
            prevState.filter.dateFrom = dateFrom;
            return prevState;
        });
    },

    onChangeTo(nil, dateTo) {
        //this.refs.dateTo.setDate(dateTo);
        this.setState(prevState => {
            prevState.filter.dateTo = dateTo;
            return prevState;
        });
    },

    onToggleDetailedByBeerStyle() {
        this.setState(prevState => {
            prevState.filter.isDetailedByBeerStyle = !prevState.filter.isDetailedByBeerStyle;
            return prevState;
        });
    },

    onToggleSelectAll(evt, isSelected) {
        const self = this;

        this.setState(prevState => {
            if (isSelected) {
                prevState.filter.selectedBeerStyleIds = map(prevState.beerStyles, beerStyle => {
                    return get(beerStyle, 'id');
                });
            } else {
                prevState.filter.selectedBeerStyleIds = [];
            }

            prevState.filter.isAllSelected = self._isAllSelected(prevState);
            return prevState;
        });
    },

    onChangeIsPlanned(evt, value) {
        this.setState(prevState => {
            prevState.filter.isShowConfirmed = value === 'CONFIRMED';
            return prevState;
        });
    },

    _onSelectBeerStyle(optionSelected) {
        const options = ComponentUtils.toMenuItemsWithNonSelectedItem(FILTER_BY_OPTIONS, 'Total');
        const optionTarget = find(options, option => option.text === (get(optionSelected, 'name') || get(optionSelected, 'text')));
        this.setState(prevState => {
            prevState.filter.filterByOptionIndex = get(optionTarget, 'payload');
            return prevState;
        });
    },
    _isAllSelected(prevState) {
        const amountSelected = get(prevState.filter.selectedBeerStyleIds, 'length') || 0;
        const amountBeerStyle = get(prevState.beerStyles, 'length') || 0;
        return amountSelected > 0 && amountSelected === amountBeerStyle;
    },

    _onSubmit() {
        let filter = cloneDeep(this.state.filter);
        filter.dateFrom = this.refs.dateFrom.getDate().toISOString();
        filter.dateTo = this.refs.dateTo.getDate().toISOString();
        filter.reportKey = ReportStore.generateKeyReportByBeerStyle(filter);
        this.setState({
            isGeneratingReport: true
        }, () => {
            InventoryStore.downloadReportXLS(filter, 'orders/by-beerstyle', () => {
                this.setState({
                    isGeneratingReport: false
                });
            }, () => {
                this.setState({
                    messageErrorItem: t('dashboard_notification_something_was_wrong')
                });
            });
        });
    },

    render() {
        const {isShowConfirmed, dateFrom, dateTo, isDetailedByBeerStyle, isAllSelected} = this.state.filter;

        return (
            React.createElement("div", {className: "report-by-beer-style"}, 
                React.createElement("div", {className: "report-by-beer-style__header"}, t('report_beer_style_title')), 
                React.createElement("div", {className: "report-by-beer-style__body"}, 
                    React.createElement("div", {className: "report-by-beer-style__body-row"}, 
                        React.createElement("label", {style: {marginBottom: '8px'}, 
                               className: "report-by-beer-style__body-row-title"}, t('report_beer_style_range')), 
                        React.createElement(DatePicker, {
                            ref: "dateFrom", 
                            style: {maxWidth: '200px', overflow: 'auto'}, 
                            value: dateFrom, 
                            onChange: this.onChangeFrom, 
                            floatingLabelText: t('report_beer_style_from')}
                        ), 
                        React.createElement(DatePicker, {
                            ref: "dateTo", 
                            value: dateTo, 
                            style: {maxWidth: '200px', overflow: 'auto'}, 
                            onChange: this.onChangeTo, 
                            floatingLabelText: t('report_beer_style_to')}
                        )
                    ), 
                    React.createElement("br", null), 
                    React.createElement("div", {className: "report-by-beer-style__body-row"}, 
                        React.createElement("label", {style: {marginBottom: 0}, className: "report-by-beer-style__body-row-title"}, t('report_beer_style_show_by')), 
                        React.createElement(DropDown, {
                            readerAttribute: "text", 
                            name: t('report_beer_style_beer_style'), 
                            items: ComponentUtils.toMenuItemsWithNonSelectedItem(FILTER_BY_OPTIONS, 'Total'), 
                            selectedIndex: this.state.filter.filterByOptionIndex + 1, 
                            onChange: this._onSelectBeerStyle}
                        )
                    ), 
                    React.createElement("br", null), 
                    React.createElement("br", null), 
                    React.createElement("div", {className: "report-by-beer-style__body-content"}, 
                        React.createElement("label", {className: "report-by-beer-style__body-row-title"}, "Selected beer styles"), 
                        React.createElement(Toggle, {
                            style: {maxWidth: '120px'}, 
                            value: isAllSelected, 
                            defaultToggled: isAllSelected, 
                            label: t('report_beer_style_select_all'), 
                            labelStyle: {fontWeight: '100'}, 
                            onToggle: this.onToggleSelectAll}
                        ), 
    
                        this.state.isFetching && React.createElement(CircularProgress, null), 
                        !this.state.isFetching && React.createElement(GridItemWithFilter, {
                            items: this.state.beerStyles, 
                            isCheckedItem: this.isSelectedBeerStyle, 
                            isChangedItem: this.isChangedBeerStyle, 
                            onCheckItem: this.onChangeBeerStyle, 
                            displayNameField: "name", 
                            iconClassNameField: "iconDetail.iconClassName", 
                            idField: "iconDetail.id", 
                            initialFilterText: this.state.filterText, 
                            nonMatchingText: t('report_beer_style_warning_non_matching_found'), 
                            keepSelectedSorting: false}
                        ), 
                        React.createElement("br", null), 
                        React.createElement("div", {className: "report-by-beer-style__body-row"}, 
                            React.createElement(Toggle, {
                                style: {maxWidth: '190px'}, 
                                value: isDetailedByBeerStyle, 
                                label: t('report_beer_style_show_by_beer_style'), 
                                labelStyle: {fontWeight: '100'}, 
                                onToggle: this.onToggleDetailedByBeerStyle}
                            )
                        ), 
                        React.createElement(RadioButtonGroup, {ref: "refPlannedConfirmed", onChange: this.onChangeIsPlanned, name: "isPlanned", 
                                          defaultSelected: isShowConfirmed ? 'CONFIRMED' : 'PLANNED'}, 
                            React.createElement(RadioButton, {
                                value: "PLANNED", 
                                label: t('report_beer_style_planned'), 
                                style: {marginTop: 16}}), 
                            React.createElement(RadioButton, {
                                value: "CONFIRMED", 
                                label: t('report_beer_style_confirmed'), 
                                style: {marginTop: 16}})
                        )
                    ), 
                    React.createElement("div", {className: "report-by-beer-style__submit"}, 
                        React.createElement(FormGroupButton, {
                            className: "primary-icon", 
                            type: "icon", 
                            label: t('report_beer_style_download_report'), 
                            onClick: this.state.isGeneratingReport ? () => {} : this._onSubmit}
                        ), 
                        this.state.isGeneratingReport && React.createElement(CircularProgress, {size: .4})
                    )
                )
            )
        );
    }
});

module.exports = ReportByBeerStyle;



/** WEBPACK FOOTER **
 ** ./src/views/ReportAdmin/ReportByBeerStyle/ReportByBeerStyle.jsx
 **/